/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Company } from '../../models/company';
import { CreateSupplierDto } from '../../models/create-supplier-dto';

export interface CreateOneBaseMgmtSupplierControllerCompany$Params {
      body: CreateSupplierDto
}

export function createOneBaseMgmtSupplierControllerCompany(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtSupplierControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtSupplierControllerCompany.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Company>;
    })
  );
}

createOneBaseMgmtSupplierControllerCompany.PATH = '/api/mgmt/suppliers';
